const moment = require('moment');

angular
  .module('core').filter('formatDateUTC', () => function formatUTC(utcStr) {
    if (!utcStr) {
      return '';
    }
    return moment(utcStr).format('LL');
  });

angular
  .module('core').filter('formatDateTimeUTC', () => function formatUTC(utcStr) {
    if (!utcStr) {
      return '';
    }
    return moment(utcStr).format('LLL');
  });

angular
  .module('core').filter('formatKoreanDate', () => function format(str) {
    if (!str) {
      return '';
    }
    return moment(str, 'YYYY년 MM월 DD일').format('LL');
  });

angular
  .module('core').filter('formatBirth', () => function format(str) {
    if (!str) {
      return '';
    }
    const birthMoment = moment(str, 'YYYYMMDD');
    if (!birthMoment.isValid()) {
      return str;
    }
    return birthMoment.format('LL');
  });
angular
  .module('core').filter('formatBirthTH', () => function format(str) {
    if (!str) {
      return '';
    }
    const birthMoment = moment(str, 'YYYYMMDD');
    if (!birthMoment.isValid()) {
      return str;
    }
    return birthMoment.format('DD / MM / YYYY');
  });
angular
  .module('core').filter('formatWeekDay', () => function format(str) {
    if (!str) {
      return '';
    }
    switch (parseInt(str, 0)) {
      case 1:
        return 'Sun';
      case 2:
        return 'Mon';
      case 3:
        return 'Tue';
      case 4:
        return 'Wed';
      case 5:
        return 'Thu';
      case 6:
        return 'Fri';
      case 7:
        return 'Sat';
      default :
        return 'Unknown';
    }
  });
angular
  .module('core').filter('formatDateStringToTimeString', () => function format(str) {
    if (!str) {
      return '';
    }
    const birthMoment = moment(str, 'YYYY-MM-DD HH:mm:ss');
    if (!birthMoment.isValid()) {
      return str;
    }
    return birthMoment.format('HH:mm');
  });



// WEBPACK FOOTER //
// ./src/app/core/filter/date.filter.js